import React from 'react';

import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useMount } from 'react-use';

import { getTranslations } from 'store/intl/service';
import { Router } from 'routes';
import { Loading, Error } from 'components/Fetch';
import { getCitc } from 'store/settings/service';
import { useAppSelector } from 'hooks';
import { loadGoogleMaps } from 'utils/GoogleMaps';

const Init = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const intlLoading = useAppSelector((state) => state.intl.loading);
  const intlError = useAppSelector((state) => state.intl.error);
  const intlMessages = useAppSelector((state) => state.intl.messages);
  const isSettingsLoading = useAppSelector((state) => state.settings.loading);
  const isSettingsError = useAppSelector((state) => state.settings.error);
  const settingsCitc = useAppSelector((state) => state.settings.citc);

  useMount(() => {
    Promise.all([dispatch(getTranslations()), dispatch(getCitc())]);
    // Started here so it is usually ready by the first address field; that field still waits on it.
    loadGoogleMaps().catch(() => undefined);
  });

  const loading = intlLoading || isSettingsLoading || !settingsCitc || !intlMessages ? true : false;

  if (loading)
    return (
      <div className="vh-100">
        <Loading />
      </div>
    );

  return (
    <>
      {intlError || isSettingsError ? (
        <Error />
      ) : (
        <>
          <Helmet>
            <meta charSet="utf-8" />
            <title>{formatMessage({ id: '6000PortalTitleKey' })}</title>
          </Helmet>
          <Router />
        </>
      )}
    </>
  );
};

export default Init;
